import React, { useEffect, useState } from 'react';
import config from '../../../../../config';
import "./BarQuestionTemplate.scss"
import { getSectionId } from '../utility';
import { SKIN_ASSESSMENT_QUESTION_TEMPLATE } from '../../../../../common/skinAssessmentConstant';

const BarQuestionTemplate = ({ question, onAnswerSelect, savedAnswerIds = [] }) => {

    const [index, setIndex] = useState(0);
    const questionLabel = getSectionId(question?.question_label);
    const titleClassName = SKIN_ASSESSMENT_QUESTION_TEMPLATE[questionLabel]?.qTitleBgClassName;

    useEffect(() => {
        if (savedAnswerIds.length) {
            const answerId = savedAnswerIds[0];
            const index = question.question_value.findIndex(opt => opt._id === answerId);

            if (index !== -1) {
                setIndex(index);
            }
        } else {
            setIndex(0);
        }
    }, [question, savedAnswerIds]);

    const handleChangeSlider = (val) => {
        const idx = parseInt(val, 10);
        setIndex(idx)
        onAnswerSelect({ canGoNext: true, nextLabel: null, question_id: question._id, question_label: question.question_label, answer_ids: [question.question_value[val]._id] });
    };

    const _renderSliderLabel = () => {
        return (
            question?.question_value?.map((item, i) => (
                <div key={`skin-bar-${item?._id}-${i}`} className={`range-label ${parseInt(i) === parseInt(index) ? 'range-hide-dot' : ''}`}>
                    <span className={`range-label-text ${parseInt(i) === parseInt(index) ? titleClassName : ''}`}>{item.value}</span>
                </div>
            ))
        )
    }

    return (
        <div className="skin-slider-wrapper">
            <div className="slider-question">{question?.question}</div>
            <div className="slider-question-desc">{question?.description}</div>
            <div className="slider-image">
                {question?.question_value[index]?.image_url &&
                    <img src={`${config.S3_URL}${question?.question_value[index]?.image_url}`} alt={question?.question_value[index]?.value} />}
            </div>
            <div className="slider-container">
                <input className={`custom-range-slider`} onChange={(e) => handleChangeSlider(e.target.value)}
                    type="range" min="0" max={question?.question_value?.length - 1} step="1" value={index} data-is-last={index === question?.question_value.length - 1} />
                <span className='custom-range-label'>{_renderSliderLabel()}</span>
            </div>
        </div>
    );
};

export default BarQuestionTemplate;